const OrbitingCircles = ({ 
  className = "", 
  children = null,
  innerDuration = 20,
  outerDuration = 15,
  innerRadius = 120,
  outerRadius = 200,
  showPath = true
}) => {
  // Inner orbit items (5 plants)
  const innerItems = ['🌱', '🌿', '🍃', '🌾', '🌵'];
  
  // Outer orbit items (7 province icons)
  const outerItems = [
    'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755686370460-punjab.webp',
    'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755686774778-Sindh.webp',
    'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/PPMS/large-1756184757122-ICT3.webp',
    'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755686953213-Balochistan.webp',
    'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755686546872-KPK.webp',
    'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755686646129-GB.webp',
    'https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755686870834-AJK.webp'
  ];

  const generateOrbitItems = (items, radius, duration, orbitClass) => {
    return items.map((item, index) => {
      const angle = (360 / items.length) * index;
      return (
        <div
          key={index}
          className={`orbit-item ${orbitClass}`}
          style={{
            '--angle': `${angle}deg`,
            '--radius': `${radius}px`,
            '--duration': `${duration}s`,
            '--delay': `${-(index * duration / items.length)}s`
          }}
        >
          <div className="orbit-circle-wrapper">
            <div className="orbit-circle d-flex align-items-center justify-content-center">
              {orbitClass === 'outer-orbit' ? (
                <img 
                  src={item} 
                  alt="Province icon" 
                  className="orbit-icon orbit-image"
                  style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }}
                />
              ) : (
                <span className="orbit-icon">{item}</span>
              )}
            </div>
          </div>
        </div>

      );
    });
  };

  return (
    <div className={`orbiting-circles-container ${className}`}>
      <style>{`
        .orbiting-circles-container {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100vw;
          height: 100vh;
          position: fixed;
          top: 0;
          left: 0;
          z-index: 9999;
        }

        /* Orbit path visual guides */
        .orbit-path {
          position: absolute;
          border: 1px solid rgba(255, 255, 255, 0.15);
          border-radius: 50%;
          pointer-events: none;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        /* Orbit container */
        .orbit-container {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          animation: rotate var(--duration) linear infinite;
        }

        /* Individual orbit items */
        .orbit-item {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) 
                     rotate(var(--angle)) 
                     translateY(calc(-1 * var(--radius)));
          animation: orbit-item var(--duration) linear infinite;
          animation-delay: var(--delay);
        }

        /* Rotation animations */
        @keyframes rotate {
          from { transform: translate(-50%, -50%) rotate(0deg); }
          to { transform: translate(-50%, -50%) rotate(360deg); }
        }

        @keyframes orbit-item {
        from { 
          transform: translate(-50%, -50%) 
                    rotate(var(--angle)) 
                    translateY(calc(-1 * var(--radius)))
                    rotate(0deg);  /* Counter-rotation start */
        }
        to { 
          transform: translate(-50%, -50%) 
                    rotate(calc(var(--angle) + 360deg)) 
                    translateY(calc(-1 * var(--radius)))
                    rotate(-360deg); /* Counter-rotation keeps logo upright */
        }
      }


        /* Circle styles */
        .orbit-circle {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          background: linear-gradient(45deg, #667eea 0%, #764ba2 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 6px 25px rgba(102, 126, 234, 0.4);
          transition: all 0.3s ease;
          border: 2px solid rgba(255, 255, 255, 0.25);
        }

        .orbit-circle:hover {
          transform: scale(1.1);
          box-shadow: 0 8px 30px rgba(102, 126, 234, 0.6);
        }

        /* Inner orbit styling */
        .inner-orbit .orbit-circle {
          width: 60px;
          height: 60px;
          background: transparent;
          box-shadow: 0 6px 20px rgba(79, 254, 123, 0.4);
        }

        .inner-orbit .orbit-circle:hover {
          box-shadow: 0 8px 25px rgba(79, 172, 254, 0.6);
        }

        /* Outer orbit styling */
        .outer-orbit .orbit-circle {
          width: 75px;
          height: 75px;
          background: transparent;
          box-shadow: 0 6px 22px rgba(147, 251, 147, 0.4);
        }

        .outer-orbit .orbit-circle:hover {
          box-shadow: 0 8px 28px rgba(240, 147, 251, 0.6);
        }

        .orbit-icon {
          color: white;
          font-size: 28px;
          filter: drop-shadow(0 2px 4px rgba(0,0,0,0.4));
        }

        .orbit-image {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          object-fit: cover;
        }

        .inner-orbit .orbit-icon {
          font-size: 24px;
        }

        /* Center content */
        .center-content {
          position: relative;
          z-index: 10;
          border-radius: 50%;
          width: 120px;
          height: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
          backdrop-filter: blur(15px);
        }

        .center-logo {
          font-size: 32px;
          font-weight: bold;
          color: white;
          text-shadow: 0 2px 6px rgba(0,0,0,0.4);
        }
      `}</style>

      {/* Orbit paths (optional visual guides) */}
      {showPath && (
        <>
          <div 
            className="orbit-path" 
            style={{ 
              width: `${innerRadius * 2}px`, 
              height: `${innerRadius * 2}px` 
            }}
          ></div>
          <div 
            className="orbit-path" 
            style={{ 
              width: `${outerRadius * 2}px`, 
              height: `${outerRadius * 2}px` 
            }}
          ></div>
        </>
      )}

      {/* Inner orbit container (5 plants, slower) */}
      <div 
        className="orbit-container"
        style={{ '--duration': `${innerDuration}s` }}
      >
        {generateOrbitItems(innerItems, innerRadius, innerDuration, 'inner-orbit')}
      </div>

      {/* Outer orbit container (7 province icons, faster) */}
      <div 
        className="orbit-container"
        style={{ '--duration': `${outerDuration}s` }}
      >
        {generateOrbitItems(outerItems, outerRadius, outerDuration, 'outer-orbit')}
      </div>

      {/* Center content */}
      <div className="center-content">
        {children || <div className="center-logo">🎨</div>}
      </div>
    </div>
  );
};

// Demo component for full-screen loading
const OrbitingCirclesDemo = () => {
  return (
    <OrbitingCircles 
      innerRadius={120}
      outerRadius={200}
      innerDuration={20}
      outerDuration={12}
      showPath={true}
    >
      <div className="text-center">
        <img 
          src={process.env.PUBLIC_URL + "/assets/images/plant_pakistan.png"}
          alt="Logo" 
          style={{ width: '200px', height: 'auto' }} 
        />
      </div>
    </OrbitingCircles>
  );
};

export default OrbitingCirclesDemo;
